module.exports = __webpack_public_path__ + "static/media/heart-fill.855f8ec1.svg";